import { GetProps, Input } from 'antd';
import { TextAreaRef } from 'antd/es/input/TextArea';
import classNames from 'classnames';
import { forwardRef } from 'react';

import { FormInput, FormInputProps } from '../FormInput/FormInput';

import { MAX_LENGTH } from './constants';

import './TextArea.scss';

export type TextAreaProps = GetProps<typeof Input.TextArea> & FormInputProps;

export const TextArea = forwardRef<TextAreaRef, TextAreaProps>(
  (
    {
      label,
      placeholder = 'Вкажіть все, що вважаєте важливим',
      rows = 4,
      className,
      errorMessage,
      maxLength = MAX_LENGTH,
      showCount = true,
      ...props
    },
    ref,
  ) => {
    return (
      <FormInput label={label} errorMessage={errorMessage} required={props.required}>
        <Input.TextArea
          ref={ref}
          {...props}
          maxLength={maxLength}
          placeholder={placeholder}
          showCount={showCount}
          status={errorMessage ? 'error' : undefined}
          autoSize={{ minRows: rows, maxRows: rows }}
          className={classNames('custom-text-area', className)}
        />
      </FormInput>
    );
  },
);

TextArea.displayName = 'TextArea';
